import {fromJS, Map } from 'immutable';
import config from 'config';
import actions from 'redux/constants/admin/services';
import history from '../../../../history';
import {servicesIsLoading} from "../../portal/services";
import {checkJsonResponseWithMessage} from "../../../../utils/actions";

export const serviceIsSubmitting = (data) => ({
  type: actions.SERVICE_IS_SUBMITTING,
  data
});

export const serviceSubmitFailed = (data) => ({
  type: actions.SERVICE_SUBMIT_FAILED,
  data
})

export const changeServiceValue = (data, key) => ({
	type: actions.SET_SERVICE_ITEM_VALUE,
	key,
	data
});


export const serviceChangeItem = (data) => ({
	type: actions.SET_SERVICE_ITEM,
	data
});

export const serviceCleanStore = () => (dispatch) => {
  dispatch(serviceChangeItem(new Map({
    code: '',
    title_classification: '',
    title: '',
    description: '',
    instruction: '',
    additional_info: ''
  })));
}

export const searchServices = (name="", limit="", offset="") => (dispatch) => {
  dispatch(servicesIsLoading(true))
  return fetch(`${config.apiHost}/service_classification/?search=${name}&limit=${limit}&offset=${offset}`)
    .then((response) => {
      if (!response.ok) {
        throw Error(response.statusText);
      }
      return response.json();
    })
    .then((json) => {
      const data = fromJS(json);
      dispatch({
        type: actions.LOAD_SERVICES_ADMIN,
        data
      });
      dispatch(servicesIsLoading(false))
      return data
    })
    .catch(e => console.log(e))
};

export const submitService = (url, serviceData, id) => (dispatch, getState) => {
  dispatch(serviceIsSubmitting(true));
  dispatch(serviceSubmitFailed(false));

  let method = id ? 'PATCH' : 'POST';
  let path = id ? `${config.apiHost}/service_classification/${id}/` : `${config.apiHost}/service_classification/`;
  let dataToSend = serviceData // id ? serviceData : assoc('id', null, serviceData)

  const options = {
    method,
    headers: {
      "Authorization": "Token " + getState().auth.get('token'),
      "Content-type": 'application/json'
    },
    body: JSON.stringify(dataToSend)
  }

  fetch(path, options)
  .then(checkJsonResponseWithMessage)
  .then((json) => {
    history.push(`${url}${json.id}`);
  })
  .catch(e => {
    dispatch(serviceSubmitFailed(e));
    console.log(e);
  })
  .then(() => {
    dispatch(serviceIsSubmitting(false))
  })
};

export const loadServiceDetail = (id) => (dispatch) => {
  fetch(`${config.apiHost}/service_classification/${id}/`)
  .then((response) => {
    if (!response.ok) {
      throw Error(response.statusText);
    }
    return response.json();
  })
  .then((json) => {
    const data = fromJS(json);
    dispatch({
      type: actions.SET_SERVICE_DETAIL_ADMIN,
      data
    });
  })
  .catch(e => console.log(e))
};

export const deleteService = (id) => (dispatch, getState) => {
  const options = {
    method: "delete",
    headers: {
       "Authorization": "Token " + getState().auth.get('token'),
    }
  };
  fetch(`${config.apiHost}/service_classification/${id}/`, options)
  .then(response => {
    if (!response.ok) {
      throw Error(response.statusText);
    }
    return null;
  })
  .then(() => {
    history.push(`/admin/services`);
  })
  .catch(e => {
    console.log(e);
  })
};



// WEBPACK FOOTER //
// ./src/redux/actions/admin/services/index.js